import { render, staticRenderFns } from "./PriceListItem.vue?vue&type=template&id=192e7e5c&"
import script from "./PriceListItem.vue?vue&type=script&lang=js&"
export * from "./PriceListItem.vue?vue&type=script&lang=js&"
import style0 from "./PriceListItem.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports